export default class DeviceConfigService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('deviceConfig/' + id, params)
	}

	getDeviceConfigResult(id, params) {
		return this.apiService.callGet('deviceConfig/' + id + '/result', params)
	}


	getEntities(params) {
		return this.apiService.callGet('deviceConfigs', params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('deviceConfig/' + id, params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('deviceConfig/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('deviceConfig/', params);
	}

	getDependency() {
		return this.apiService.callGet('deviceConfig/dependency/')
	}
}



// WEBPACK FOOTER //
// ./src/service/DeviceConfigService.js